import { DateTime } from "luxon";

import store from "../vue/store/index";

const localStorageKey = "application-reset-all";

let handler = () => {
  resetLocalStorage();
};

function init() {
  // Set up a listener to watch for changes in other browser tabs.
  window.addEventListener(
    "storage",
    (event) => {
      if (event.key !== localStorageKey) {
        return;
      }
      handler(() => {});
    },
    false
  );
}

function resetLocalStorage() {
  store.commit("emptyFavourites");
  store.commit("localSave/remove", { type: "right-of-occupancy" });
  store.commit("localSave/remove", { type: "owner-occupancy" });
  store.commit("localSave/remove", { type: "rental" });
}

function resetAll() {
  handler(resetLocalStorage);

  // Just set *something* to localstorage to trigger change in other browser tabs.
  localStorage.setItem(localStorageKey, DateTime.local().toISO());
}

/**
 * Handler is a callback function that is called on all browser tabs when a "resetAll event" occurs. The handler gets a
 * function as a parameter that must be called in to reset local storage. On other tabs (where the "event" *didn't*
 * originate from) the passed function doesn't do anything -> it will only run once across all tabs.
 *
 * @param newHandler
 */
function setHandler(newHandler) {
  handler = newHandler;
}

export default {
  init,
  resetAll,
  setHandler,
};
